import config from "../../app.json";
import "./volunteer-card.scss";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import Image from "../Image/image";

function VolunteerCard(props) {
  const { id, firstName, lastName, email, role, pictureGuid } = props;

  let navigate = useNavigate();

  const handleEditUser = (id) => {
    return navigate(`/users/edit/${id}`, { replace: false });
  };
  

  return (
    <div className="volunteer-card">
      <div className="user-primary-info">
        <div className="user-avatar">
          <Image radius={16} src={pictureGuid ? config.API + "/api/file/download/?guid=" + pictureGuid : null} alt="alt" width={56} height={56} />
        </div>
        <div className="user-info">
            <div className="user-info-name">{firstName} {lastName}</div>
            <div className="user-info-email">{email}</div>
            <div className="user-info-role">{role == "ROLE_CHURCH_ADMIN" ? "Admin" : role == "ROLE_CHURCH_PRODUCER" ? "Producer" : "Media Manager"}</div>
        </div>
      </div>
      <div className="user-action" >
        <Button className="user-edit-btn" onClick={() => handleEditUser(id)}>Edit</Button>
      </div>
    </div>
  );
}

export default VolunteerCard;
